import { render, staticRenderFns } from "./DrugOrdersInboxFill.vue?vue&type=template&id=52189d70&"
import script from "./DrugOrdersInboxFill.vue?vue&type=script&lang=js&"
export * from "./DrugOrdersInboxFill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports